import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import FloatingShapes from "@/components/FloatingShapes";
import Nav from "@/components/Nav";
import { toast } from "sonner";
import api from "@/lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("Password must be at least 6 characters."); return; }
    if (password !== confirm) { toast.error("Passwords don't match."); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated — please sign in.");
      setTimeout(() => nav("/login"), 1000);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "This reset link is invalid or has expired.");
    } finally { setBusy(false); }
  };

  return (
    <div className="relative min-h-screen grain" data-testid="reset-password-page">
      <FloatingShapes /><Nav />
      <main className="relative z-10 max-w-md mx-auto px-6 pt-32 pb-20">
        <h1 className="font-display text-5xl text-center">New password</h1>
        <p className="font-hand text-stone-500 text-2xl text-center mt-2">choose something memorable</p>

        {!token ? (
          <div className="sticky-card p-8 mt-10 text-center" data-testid="reset-no-token">
            <p className="text-stone-700">This reset link is missing its token. Please request a new one.</p>
            <Link to="/forgot-password" className="btn-primary inline-flex mt-6">Request a new link</Link>
          </div>
        ) : (
          <form onSubmit={onSubmit} className="sticky-card p-8 mt-10 space-y-4" data-testid="reset-password-form">
            <div>
              <label className="text-xs uppercase tracking-[0.18em] text-stone-500">New password</label>
              <input type="password" required value={password} onChange={e=>setPassword(e.target.value)}
                     className="input mt-2" data-testid="reset-password-input" placeholder="••••••••"/>
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.18em] text-stone-500">Confirm password</label>
              <input type="password" required value={confirm} onChange={e=>setConfirm(e.target.value)}
                     className="input mt-2" data-testid="reset-confirm-input" placeholder="••••••••"/>
            </div>
            <button type="submit" disabled={busy} className="btn-primary w-full mt-2" data-testid="reset-submit-button">
              {busy ? "Updating…" : "Update password"}
            </button>
          </form>
        )}
      </main>
    </div>
  );
}
